import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Home from './pages/Home';
import About from './pages/About';
import Shop from './pages/Shop';
import Cart from './pages/Cart';
import Track from './pages/Track';
// import Card from './pages/Card';
import Wallet from './pages/Wallet';
import MetalWallet from './pages/MetalWallet';
// import Stand from './pages/Stand';
// import Powerbank from './pages/Powerbank';
// import Utility from './pages/Utility';
// import Hunting from './pages/Hunting';
// import Knife from './pages/Knife';
// import Bottle from './pages/Bottle';
// import MetalPencil from './pages/MetalPencil';
import CollegeWallet from './pages/CollegeWallet';
import GroomsmenGifts from './pages/GroomsmenGifts';
import CollegeParentGifts from './pages/CollegeParentGifts';
import ProfessionalWallet from './pages/ProfessionalWallet';
import FathersDayGifts from './pages/FathersDayGifts';
import GraduationGifts from './pages/GraduationGifts';
import EdcWallet from './pages/EdcWallet';
import GiftsForMen from './pages/GiftsForMen';
import BulkOrders from './pages/BulkOrders';
import BrikVsRidge from './pages/BrikVsRidge';
import TrackerWallet from './pages/TrackerWallet';
import Privacy from './pages/Privacy';
import Tnc from './pages/Tnc';
import Refunds from './pages/Refunds';
import Success from './pages/Success';
import Cancelled from './pages/Cancelled';
import Newsletter from './pages/Newsletter';
import NotFound from './pages/NotFound';
import { CartProvider } from './context/CartContext';
import { startPingService } from './utils/pingService';


// Guide library loads as its own chunk so article text never weighs down
// the main bundle.
const GuidesIndex = React.lazy(() => import('./pages/GuidesIndex'));
const GuideArticle = React.lazy(() => import('./pages/GuideArticle'));

const MODEL_URLS = [
  '/models/open.glb',
  '/models/completelyclosed.glb',
  '/models/cashhhmoney.glb',
];

function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

function App() {
  // Start ping service to keep backend instance alive
  useEffect(() => {
    const cleanup = startPingService();
    return cleanup; // Cleanup on unmount
  }, []);

  // Warm the HTTP cache for the 3D models so model-viewer renders instantly
  // when a user navigates to a page that uses them.
  useEffect(() => {
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));
    idle(() => {
      MODEL_URLS.forEach((url) => {
        fetch(url, { cache: 'force-cache' }).catch(() => {});
      });
    });
  }, []);

  return (
    <HelmetProvider>
      <CartProvider>
        <Router>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/track" element={<Track />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/metal-wallet" element={<MetalWallet />} />
            <Route path="/wallet-for-college-students" element={<CollegeWallet />} />
            <Route path="/groomsmen-gifts" element={<GroomsmenGifts />} />
            <Route path="/gifts-for-college-students" element={<CollegeParentGifts />} />
            <Route path="/wallet-for-professionals" element={<ProfessionalWallet />} />
            <Route path="/fathers-day-gifts" element={<FathersDayGifts />} />
            <Route path="/graduation-gifts" element={<GraduationGifts />} />
            <Route path="/edc-wallet" element={<EdcWallet />} />
            <Route path="/gifts-for-men" element={<GiftsForMen />} />
            <Route path="/bulk" element={<BulkOrders />} />
            <Route
              path="/guides"
              element={
                <React.Suspense fallback={null}>
                  <GuidesIndex />
                </React.Suspense>
              }
            />
            <Route
              path="/guides/:slug"
              element={
                <React.Suspense fallback={null}>
                  <GuideArticle />
                </React.Suspense>
              }
            />
            <Route path="/brik-vs-ridge" element={<BrikVsRidge />} />
            <Route path="/wallet-with-built-in-tracker" element={<TrackerWallet />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/tnc" element={<Tnc />} />
            <Route path="/exchange-and-delivery" element={<Refunds />} />
            {/* Old URL kept as an alias; vercel.json 301s it, this covers dev */}
            <Route path="/exchange&delivery" element={<Refunds />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/success" element={<Success />} />
            <Route path="/cancel" element={<Cancelled />} />
            <Route path="/setup" element={<ExternalRedirect to="https://www.youtube.com/watch?v=vqtnGxcS0Rs" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </CartProvider>
    </HelmetProvider>
  );
}

// Fires a GA4 page_view on every SPA route change so dwell time and
// engagement are tracked per page (not just the initial load).
function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);
  return null;
}

export default App;
